import React from 'react';
import styled from 'styled-components/macro';
import { colors } from '../../styles/Colors';
import { trackFontHeavySmall, trackFont, trackFontSmall } from '../../styles/Font';
import { columnFormat, rowFormat, columns } from './List.js';

const RowContainer = styled.div`
  ${rowFormat}
  margin-top: 10px;
  height: 40px;
  background: ${colors.foreground};
  border-radius: 5px;
`;

const RowItem = styled.div`
  ${columnFormat}
  flex: ${({ flexSize }) => flexSize};
  ${({ isTitle }) => (isTitle === 'title' ? trackFontHeavySmall : trackFont)}
`;

const AvailabilityText = styled.span`
  ${trackFontSmall}
`;

const Row = ({ agencyInfo }) => (
  <RowContainer>
    {columns.map(({ flexSize, name }, index) => (
      <RowItem
        flexSize={flexSize}
        isTitle={index === 0 ? 'title' : 'not title'}
        key={`list-row-${name}`}
      >
        {agencyInfo[index] ? (
          index === 0 ? (
            agencyInfo[index].agency_url ? (
              <a
                href={agencyInfo[index].agency_url}
                target="_blank"
                rel="noreferrer noopener"
                title={agencyInfo[index].agency_url}
              >
                {agencyInfo[index].agency_name}
              </a>
            ) : (
              <span title={agencyInfo[index].agency_name}>{agencyInfo[index].agency_name}</span>
            )
          ) : (
            <>
              <span role="img" aria-label="CHECK" title={agencyInfo[index]}>
                ✅
              </span>
              &nbsp;
              <a
                href={agencyInfo[index]}
                target="_blank"
                rel="noreferrer noopener"
                title={agencyInfo[index]}
              >
                <AvailabilityText>Available</AvailabilityText>
              </a>
            </>
          )
        ) : (
          <span title="Not Available">
            <span role="img" aria-label="X" title="Not Available">
              ❌
            </span>
            &nbsp;<AvailabilityText>Not Available</AvailabilityText>
          </span>
        )}
      </RowItem>
    ))}
  </RowContainer>
);

export default Row;
